import AIMediaLoader from './AIMediaLoaderContainer';

export default AIMediaLoader;
